var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconFb = function SvgIconFb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.118,
    height: 28.847,
    viewBox: "0 0 15.118 28.847",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M632.956,1354.133a.093.093,0,0,1,.105-.105h4.209c.14,0,.14,0,.14-.14.07-.456.105-.912.175-1.333s.105-.877.175-1.3.105-.877.175-1.3c.035-.351.105-.666.14-1.017v-.07h-5.016c-.105,0-.105,0-.105-.105v-3.543a2.42,2.42,0,0,1,.14-.877,1.7,1.7,0,0,1,1.228-1.157,4.613,4.613,0,0,1,1.193-.14h2.7v-4.665c-.175-.035-.351-.035-.491-.07l-1.508-.105c-.807-.035-1.614-.07-2.42-.035a6.971,6.971,0,0,0-2.911.7,5.617,5.617,0,0,0-2.876,3.262,6.045,6.045,0,0,0-.386,1.754c-.035.386-.07.772-.07,1.158v3.648c0,.105,0,.105-.105.105H623.1v5.086c0,.14,0,.14.14.14h4.174c.175,0,.14,0,.14.14v12.838h5.367v-12.838A.034.034,0,0,0,632.956,1354.133Z",
    transform: "translate(-623.1 -1338.158)",
    fill: "#fff"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_fb.ccfcd2b2.svg";
export { ForwardRef as ReactComponent };